/** Map click-based Narration UI values ↔ backend create/recommend fields. */

export const NARRATION_UI_STYLE_TO_CATALOG = {
  pixar: 'pixar_cinematic',
  anime: 'anime',
  ghibli: 'studio_ghibli',
  hyper_real: 'hyperrealistic',
  cyber_synth: 'cyberpunk_neon',
  noir_sketch: 'noir_film',
};

export const NARRATION_CATALOG_TO_UI_STYLE = {
  pixar_cinematic: 'pixar',
  anime: 'anime',
  studio_ghibli: 'ghibli',
  hyperrealistic: 'hyper_real',
  photoreal_cinematic: 'hyper_real',
  cyberpunk_neon: 'cyber_synth',
  noir_film: 'noir_sketch',
};

export const NARRATION_UI_IMAGE_PROVIDER_TO_API = {
  gemini_nano: 'nano_banana',
  nano_banana: 'nano_banana',
  runway_gen3: 'runway',
  runway: 'runway',
  minimax: 'minimax',
  veo3: 'veo3',
  inhouse: 'inhouse',
  bedrock: 'inhouse',
};

export function mapUiVisualStyleToCatalog(uiId) {
  return NARRATION_UI_STYLE_TO_CATALOG[uiId] || uiId || 'pixar_cinematic';
}

export function mapCatalogVisualStyleToUi(catalogKey) {
  return NARRATION_CATALOG_TO_UI_STYLE[catalogKey] || catalogKey || 'pixar';
}

export function mapUiImageProviderToApi(uiId) {
  return NARRATION_UI_IMAGE_PROVIDER_TO_API[uiId] || 'nano_banana';
}

export function buildNarrationCreatePayload({
  title,
  topic,
  tone,
  visualStyleUi,
  imageProviderUi,
  ttsProvider,
  voiceId,
  murfLocale,
  voiceSpeed,
  voicePitch,
  segmentCount,
  aspectRatio,
  language,
  genreId,
  autoPublishYoutube,
  autoPublishInstagram,
}) {
  const provider = (ttsProvider || 'auto').toLowerCase();
  const payload = {
    title: (title || '').trim() || 'Narration Story',
    topic: (topic || '').trim(),
    full_script: '',
    tone: tone || 'inspiring',
    visual_style: mapUiVisualStyleToCatalog(visualStyleUi),
    image_provider: mapUiImageProviderToApi(imageProviderUi),
    image_aspect_ratio: aspectRatio || '16:9',
    segment_count: Number(segmentCount) || 6,
    language: language || 'en',
    tts_provider: provider === 'heygen' ? 'auto' : provider,
    voice_id: voiceId || undefined,
    voice_speed: voiceSpeed,
    voice_pitch: voicePitch,
    genre_id: genreId || '',
    full_automation: true,
    generate_ai_video_during_pipeline: true,
    include_subtitles: true,
    auto_publish_youtube: Boolean(autoPublishYoutube),
    auto_publish_instagram: Boolean(autoPublishInstagram),
    youtube_publish_language: language || 'en',
  };

  if (provider === 'elevenlabs' && voiceId) {
    payload.narrator_elevenlabs_voice_id = voiceId;
  } else if (provider === 'murf' && voiceId) {
    payload.narrator_murf_voice_id = voiceId;
    if (murfLocale) payload.narrator_murf_locale = murfLocale;
  } else if (provider === 'minimax' && voiceId) {
    payload.narrator_minimax_voice_id = voiceId;
  }

  return payload;
}
